<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default { name: 'App' }
</script>

<style>
/* ==================== 全局商务主题 ==================== */
:root {
  --primary: #1e3a8a;
  --primary-dark: #15264d;
  --primary-light: #3b82f6;
  --primary-bg: #eff6ff;
  --primary-50: #eff6ff;
  --accent: #2563eb;
  --accent-light: #93bbfd;
  --success: #059669;
  --warning: #d97706;
  --danger: #dc2626;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --bg-page: #f1f5f9;
  --bg-card: #ffffff;
  --border: #e2e8f0;
  --shadow: 0 1px 2px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.03);
  --shadow-md: 0 4px 6px rgba(0,0,0,0.04), 0 2px 4px rgba(0,0,0,0.02);
  --radius: 8px;
  --radius-sm: 6px;
}

html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Inter', 'PingFang SC', 'Microsoft YaHei', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  background: var(--bg-page);
  color: var(--text-primary);
}

* { box-sizing: border-box; }

::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

/* ===== 对话框 ===== */
.edu-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1e293b, #15264d);
  padding: 16px 24px;
  border-radius: var(--radius) var(--radius) 0 0;
}
.edu-dialog .el-dialog__title { color: #fff; font-size: 15px; font-weight: 600; }
.edu-dialog .el-dialog__headerbtn { top: 16px; }
.edu-dialog .el-dialog__headerbtn .el-dialog__close { color: #fff; font-size: 18px; }
.edu-dialog .el-dialog__headerbtn .el-dialog__close:hover { color: #cbd5e1; }
.edu-dialog .el-dialog__body { padding: 24px; }
.edu-dialog .el-dialog__footer { border-top: 1px solid var(--border); padding: 14px 24px; }

/* ===== 表格 ===== */
.el-table { border-radius: var(--radius-sm); overflow: hidden; }
.el-table th {
  background: #f8fafc !important;
  color: var(--text-primary) !important;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 2px solid #e2e8f0 !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td { background: #fafbfc; }
.el-table__body tr:hover > td { background: #f1f5f9 !important; }

/* ===== 卡片 ===== */
.el-card {
  border-radius: var(--radius) !important;
  box-shadow: var(--shadow) !important;
  border: 1px solid var(--border) !important;
  transition: box-shadow 0.2s;
}
.el-card:hover { box-shadow: var(--shadow-md) !important; }

/* ===== 按钮 ===== */
.el-button--primary {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
}
.el-button--primary:hover {
  background: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}
.el-button--primary.is-plain {
  color: var(--primary) !important;
  background: var(--primary-bg) !important;
  border-color: #93bbfd !important;
}
.el-button--primary.is-plain:hover {
  background: var(--primary) !important;
  color: #fff !important;
}
.el-button--success { background: var(--success) !important; border-color: var(--success) !important; }
.el-button--warning { background: var(--warning) !important; border-color: var(--warning) !important; }
.el-button--danger { background: var(--danger) !important; border-color: var(--danger) !important; }

/* ===== 分页 ===== */
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: var(--primary) !important;
  color: #fff !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover { color: var(--primary) !important; }

/* ===== 输入框聚焦 ===== */
.el-input.is-active .el-input__inner, .el-input__inner:focus { border-color: var(--primary) !important; }
.el-select .el-input.is-focus .el-input__inner { border-color: var(--primary) !important; }
.el-textarea__inner:focus { border-color: var(--primary) !important; }
.el-range-editor.is-active, .el-range-editor.is-active:hover { border-color: var(--primary) !important; }

/* ===== 单选/复选 ===== */
.el-radio__input.is-checked .el-radio__inner { background: var(--primary) !important; border-color: var(--primary) !important; }
.el-checkbox__input.is-checked .el-checkbox__inner { background: var(--primary) !important; border-color: var(--primary) !important; }
.el-radio__input.is-checked + .el-radio__label { color: var(--primary) !important; }
.el-checkbox__input.is-checked + .el-checkbox__label { color: var(--primary) !important; }

/* ===== Switch ===== */
.el-switch.is-checked .el-switch__core { background: var(--primary) !important; border-color: var(--primary) !important; }

/* ===== Tabs ===== */
.el-tabs__active-bar { background: var(--primary) !important; }
.el-tabs__item.is-active { color: var(--primary) !important; font-weight: 600; }
.el-tabs__item:hover { color: var(--primary) !important; }

/* ===== Tag ===== */
.el-tag--primary { background: #eff6ff !important; border-color: #bfdbfe !important; color: var(--primary) !important; }
.el-tag--success { background: #ecfdf5 !important; border-color: #a7f3d0 !important; color: #065f46 !important; }
.el-tag--warning { background: #fffbeb !important; border-color: #fde68a !important; color: #92400e !important; }
.el-tag--danger { background: #fef2f2 !important; border-color: #fecaca !important; color: #991b1b !important; }
.el-tag--info { background: #f1f5f9 !important; border-color: #cbd5e1 !important; color: #475569 !important; }

/* ===== 消息 ===== */
.el-message--success { background: #ecfdf5 !important; border-color: #6ee7b7 !important; }
.el-message--warning { background: #fffbeb !important; border-color: #fcd34d !important; }
.el-message--error { background: #fef2f2 !important; border-color: #fca5a5 !important; }

/* ===== 侧边栏暗色菜单 ===== */
.dark-menu .el-menu-item.is-active {
  background: rgba(255,255,255,0.12) !important;
  border-right: 3px solid #60a5fa;
}
.dark-menu .el-menu-item:hover { background: rgba(255,255,255,0.06) !important; }
.dark-menu .el-submenu__title:hover { background: rgba(255,255,255,0.06) !important; }

/* 二级菜单左缩进去掉 */
.dark-menu .el-menu .el-menu-item { padding-left: 20px !important; }
/* 一级菜单文字加粗加大 */
.dark-menu .el-submenu__title { font-size: 16px !important; font-weight: 700 !important; }
/* 隐藏伸缩箭头 */
.dark-menu .el-submenu__icon-arrow { display: none !important; }

/* ===== 下拉菜单 ===== */
.el-dropdown-menu__item:hover { background: var(--primary-bg) !important; color: var(--primary) !important; }

/* ===== 告警 ===== */
.el-alert--info { background: #eff6ff !important; border-color: #bfdbfe !important; }
.el-alert--warning { background: #fffbeb !important; border-color: #fde68a !important; color: #92400e !important; }

/* ===== 分割线 ===== */
.el-divider__text { background: #fff; color: var(--text-secondary); font-weight: 500; }

/* 表格操作按钮间距 */
.el-table .cell .el-button { margin: 2px 3px; }
</style>
